import type { Editor } from '@tiptap/core';
import type { Node as PMNode } from '@tiptap/pm/model';

export type TFieldNodeMatch = { pos: number; node: PMNode };

/**
 * Find the first node in the document whose `fieldId` attribute matches.
 *
 * Field IDs are UUIDs - unique across the entire document - so no type-name
 * check is needed. Used after field insertion (to set post-creation selection)
 * and by the dropdown bubble menu (to update attributes by position).
 */
const findNodeByFieldId = (editor: Editor, fieldId: string): TFieldNodeMatch | null => {
  let result: TFieldNodeMatch | null = null;
  editor.state.doc.descendants((node, pos) => {
    if (result) return false;
    if (node.attrs?.fieldId === fieldId) {
      result = { pos, node };
      return false;
    }
  });
  return result;
};

export default findNodeByFieldId;
